// apps/admin/src/lib/permission-match.ts
//
// SEC-5 — the ONE permission matcher of the admin SPA. Same rules as the
// backend `permissionMatches` in
// apps/api/src/modules/auth/middlewares/permission.middleware.ts; a test in
// apps/api (admin-fe-permission-keys.test.ts) checks both agree.
//
// Grants come from the backend (`/auth/me/permissions`) only — never derived
// from role names on the client.

/**
 * True when `grant` covers `required`:
 *   - `*` and `*:*` match every key, including keys without a colon.
 *   - A `*` segment matches the rest of `required`.
 *   - Otherwise every segment must match and both keys have the same length
 *     (no implicit trailing wildcard).
 */
export function permissionMatches(grant: string, required: string): boolean {
  if (grant === '*' || grant === '*:*') return true;
  const grantParts = grant.split(':');
  const reqParts = required.split(':');
  if (grantParts.length > reqParts.length) return false;
  for (let i = 0; i < grantParts.length; i++) {
    const g = grantParts[i];
    if (g === '*') return true;
    if (g !== reqParts[i]) return false;
  }
  return grantParts.length === reqParts.length;
}

/** True when any grant in `grants` covers `required`. */
export function hasGrant(grants: Iterable<string> | undefined | null, required: string): boolean {
  if (!grants) return false;
  for (const grant of grants) {
    if (permissionMatches(grant, required)) return true;
  }
  return false;
}
